import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { searchUsersByName } from "../api/auth";
import type { UserSearchResult } from "../types/auth";

export function useUserSearch(query: string, debounceMs = 300) {
  const [debounced, setDebounced] = useState(query);

  useEffect(() => {
    const t = window.setTimeout(() => setDebounced(query.trim()), debounceMs);
    return () => window.clearTimeout(t);
  }, [query, debounceMs]);

  const enabled = debounced.length >= 2;

  const { data, isFetching } = useQuery({
    queryKey: ["user-search", debounced],
    queryFn: async (): Promise<UserSearchResult[]> => {
      const { search_results } = await searchUsersByName(debounced);
      return search_results ?? [];
    },
    enabled,
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    results: enabled ? data ?? [] : [],
    loading: enabled && isFetching,
  };
}
